<template>
    <div id="secure">
        <!-- START NAV -->
        <TopMenu />
        <!-- END NAV -->
        <div class="container">
            <div class="columns">
                <div class="column is-12">
                    <nav class="breadcrumb" aria-label="breadcrumbs">
                        <ul>
                            <li>
                                <a v-on:click="goHome()">Super Admin</a>
                            </li>
                            <li>
                                <a v-on:click="goSuperItems()">Items</a>
                            </li>
                            <li class="is-active">
                                <a href="#" aria-current="page">Categories</a>
                            </li>
                        </ul>
                    </nav>
                </div>
            </div>        
            <b-notification type="is-danger" :closable="false" style="padding: 10px; font-size: 12px;">
                <center>Please make sure each item is selected in ONLY ONE CATEGORY. Else it may cause duplicate on the schools that import these categories/items.</center>
            </b-notification>
            <div class="columns">
                <div class="column is-12">
                    <div class="card is-hidden1">
                        <div class="card-header">
                            <p class="card-header-title">Categories</p>
                            <a class="button is-primary" v-on:click="addItemForm()" style="margin: 5px;" v-show="!addItem">Add A Category</a>
                            <a class="button is-warning" v-on:click="closeAddItemForm()" style="margin: 5px" v-show="addItem">Close Add Category</a>
                        </div>
                        <div class="card-content" v-show="addItem">                   
                            <div class="content">                                
                                <b-message type="is-info">
                                    Categories can be assigned to items, and it is used to calculate the average points of the item according to the value you set below.
                                </b-message>
                                <div class="columns">
                                    <div class="column is-6">
                                        <input class="input is-success" type="text" placeholder="Category Name (E.g.: O Level, Time Management, Recycle Program etc)" v-model="name">
                                    </div>
                                    <div class="column is-6">
                                        <input class="input" type="number" placeholder="Average Marks (E.g.: 5 for gpa or 100 for percentage)" v-model="points">
                                    </div>
                                </div>
                                <div class="columns">
                                    <div class="column is-1">
                                        Colour:
                                    </div>
                                    <div class="column is-5">
                                        <slider-picker v-model="colour" />
                                    </div>
                                    <div class="column">
                                        <button class='button is-primary  is-fullwidth' v-on:click="createCategory()" >Create</button>
                                    </div>
                                </div>                                
                            </div>
                            <loading :active.sync="isLoading1" 
                                :can-cancel="false" 
                                :is-full-page="true">
                            </loading>
                        </div>
                    </div>
                    <div class="card is-hidden1">
                        <div class="card-content">
                            <loading :active.sync="isLoading" 
                                :can-cancel="false" 
                                :is-full-page="true">
                            </loading>
                            <category-list v-bind:listCategory="listCategory" :listItem="listItem" class="columns is-multiline"></category-list>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
import TopMenu from "./TopMenu";
import CategoryList from './CategoryList';
import axios from "axios";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import { ToastProgrammatic as Toast } from 'buefy'
import { Slider } from 'vue-color'

export default {
    name: "SuperCategories",
    components: {
        TopMenu,
        Loading,
        CategoryList,
        'slider-picker': Slider,
    },
    data() {
        return {
            superId: "",
            superEmail: "",
            isLoading: false,
            isLoading1: false,
            listCategory: [],
            listItem: [],
            addItem: false,
            name: '',
            points: '',
            colour: '#0C4BF7',
            status: 1
        };
    },
    created() {
        this.superId = localStorage.getItem("superId");
        this.superEmail = localStorage.getItem("superEmail");
        this.getCategories();
        this.getItems();
    },
    beforeMount() {
        this.$emit("authenticated", true);
    },
    mounted() {},
    methods: {
        createCategory(){
            let self = this;
            var name = self.name;
            var points = self.points;
            var colour = self.colour;
            var selectedColour = "";
            if (!colour.hex){
                selectedColour = "#0C4BF7"
            }else{
                selectedColour = colour.hex
            }

            if ((!name) || (name.length < 1)){
                Toast.open({
                    message: "Please enter the category name",
                    type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                    duration: 3000
                })
                return false;
            }else{
                name = name.trim()
            }
            if (!points){
                Toast.open({
                    message: "Please enter the value for the average marks",
                    type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                    duration: 3000
                })
                return false;
            }else{
                points = parseFloat(points)
            }

            self.isLoading1 = true;

            axios.defaults.headers.common["Authorization"] = localStorage.getItem("jwtToken");
            axios.defaults.responseType = "json";
            axios.post(process.env.MY_URL + "/super/category/add", {
                superEmail: localStorage.getItem("superEmail"),
                name: name,
                points: points,
                colour: selectedColour,
            })
            .then(response => {
                self.isLoading1 = false;
                if (response.data.success == false) {
                    Toast.open({
                        message: response.data.msg,
                        type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                        duration: 5000
                    })
                } else {
                    Toast.open({
                        color: 'is-dark', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                        message: response.data.msg,
                        type: 'is-success',
                        duration: 3000
                    })
                }
                self.name = ""
                self.points = ""
                self.getCategories()
            })
            .catch(e => {
                console.log(e.response);
                if (e.response.status == 400) {
                    Toast.open({
                        message: e.response.data.msg,
                        type: "is-danger", //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                        duration: 5000
                    });
                } else {
                    Toast.open({
                        message:
                            "Sorry, an error has occurred. Please try again: " + e.response.statusText,
                        type: "is-danger", //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                        duration: 5000
                    });
                }
                self.isLoading1 = false;
            });
        },
        addItemForm(){
            this.addItem = true;
        },
        closeAddItemForm(){
            this.addItem = false;
        },
        getCategories() {
            let self = this;
            self.isLoading = true;

            self.listCategory = []

            axios.defaults.headers.common["Authorization"] = localStorage.getItem("jwtToken");
            axios.defaults.responseType = "json";
            axios.post(process.env.MY_URL + "/super/category/list", {
                    superEmail: localStorage.getItem("superEmail"),
                    withItems: 1
                })
                .then(response => {
                    if (response.data.success == true) {
                        self.listCategory = response.data.listCategory
                        console.log("225 self.listCategory.length: " + self.listCategory.length)
                        console.log(self.listCategory)
                    } else {
                        Toast.open({
                            message: e.response.data.msg,
                            type: "is-danger", //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                            duration: 5000
                        });
                    }
                    self.isLoading = false;
                })
                .catch(e => {
                    console.log(e.response);
                    if (e.response.status == 400) {
                        Toast.open({
                            message: e.response.data.msg,
                            type: "is-danger", //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                            duration: 5000
                        });
                    } else {
                        Toast.open({
                            message:
                                "Sorry, an error has occurred. Please try again: " + e.response.statusText,
                            type: "is-danger", //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                            duration: 5000
                        });
                    }
                    self.isLoading = false;
                });
        },
        getItems() {
            let self = this;
            self.isLoading = true;

            self.listItem = []

            axios.defaults.headers.common["Authorization"] = localStorage.getItem("jwtToken");
            axios.defaults.responseType = "json";
            axios.post(process.env.MY_URL + "/super/item/list", {
                    superEmail: localStorage.getItem("superEmail"),
                    withItems: 1
                })
                .then(response => {
                    if (response.data.success == true) {
                        self.listItem = response.data.listItem
                        console.log("272 self.listItem.length: " + self.listItem.length)
                        console.log(self.listItem)
                    } else {
                        Toast.open({
                            message: e.response.data.msg,
                            type: "is-danger", //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                            duration: 5000
                        });
                    }
                    self.isLoading = false;
                })
                .catch(e => {
                    console.log(e.response);
                    if (e.response.status == 400) {
                        Toast.open({
                            message: e.response.data.msg,
                            type: "is-danger", //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                            duration: 5000
                        });
                    } else {
                        Toast.open({
                            message:
                                "Sorry, an error has occurred. Please try again: " + e.response.statusText,
                            type: "is-danger", //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                            duration: 5000
                        });
                    }
                    self.isLoading = false;
                });
        },
        goHome() {
            this.$router.push({
                name: "SuperHome"
            });
        },
        goSuperItems() {
            this.$router.push({
                name: "SuperItems"
            });
        },
        goCreateTemplate() {
            this.$router.push({
                name: "SuperTemplateAdd"
            });
        }
    }
};
</script>

<style scoped>
html,
body {
    font-size: 16px;
    line-height: 1.5;
    height: 100%;
    background: #ecf0f3;
}
nav.navbar {
    border-top: 4px solid #276cda;
    margin-bottom: 1rem;
}
.navbar-item.brand-text {
    font-weight: 300;
}
.navbar-item,
.navbar-link {
    font-size: 14px;
    font-weight: 700;
}
.columns {
    width: 100%;
    height: 100%;
    margin-left: 0;
}
.menu-label {
    color: #8f99a3;
    letter-spacing: 1.3;
    font-weight: 700;
}
.menu-list a {
    color: #0f1d38;
    font-size: 14px;
    font-weight: 700;
}
.menu-list a:hover {
    background-color: transparent;
    color: #276cda;
}
.menu-list a.is-active {
    background-color: transparent;
    color: #276cda;
    font-weight: 700;
}
.card {
    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.18);
    margin-bottom: 2rem;
}
.card-header-title {
    color: #8f99a3;
    font-weight: 400;
}
.info-tiles {
    margin: 1rem 0;
}
.info-tiles .subtitle {
    font-weight: 300;
    color: #8f99a3;
}
.hero.welcome.is-info {
    background: #36d1dc;
    background: -webkit-linear-gradient(to right, #5b86e5, #36d1dc);
    background: linear-gradient(to right, #5b86e5, #36d1dc);
}
.hero.welcome .title,
.hero.welcome .subtitle {
    color: hsl(192, 17%, 99%);
}
.card .content {
    font-size: 14px;
}
.card-footer-item {
    font-size: 14px;
    font-weight: 700;
    color: #8f99a3;
}
.card-table .table {
    margin-bottom: 0;
}
.events-card .card-table {
    max-height: 250px;
    overflow-y: scroll;
}
</style>



// WEBPACK FOOTER //
// src/components/Super/Categories.vue